import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable, signal } from '@angular/core';
import { catchError, Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { APIUrls } from '../enums/apiUrls';
import { ClientListForMatterFilterResponse } from '../interfaces/Admin/Matter/ClientListForMatterFilterResponse';
import { UserLookup } from '../interfaces/Admin/User/UserLookupList';
import { CountryList } from '../interfaces/Lookup/Country';
import { HJSClientLookup, Lookup, LookupItem } from '../interfaces/Lookup/Lookup';
import { TechUsedResponse } from '../interfaces/Lookup/Techused';

@Injectable({
  providedIn: 'root',
})
export class BackendLookupService {
  constructor(private httpClient: HttpClient) { }

  getCountries(): Observable<CountryList[]> {
    return this.httpClient.get<CountryList[]>(`${environment.apiUrl}/Lookup/GetCountries`);
  }

  getClientRiskIndicators(): Observable<Lookup[]> {
    return this.httpClient.get<Lookup[]>(`${environment.apiUrl}/Lookup/GetClientRiskIndicators`);
  }

  getHJSClientLookup(): Observable<HJSClientLookup[]> {
    return this.httpClient.get<HJSClientLookup[]>(`${environment.apiUrl}/Lookup/GetHJSClientLookup`);
  }

  getSolicitors(): Observable<UserLookup[]> {
    return this.httpClient.get<UserLookup[]>(`${environment.apiUrl}/Lookup/GetSolicitorLookup`);
  }

  clientLookupItems = signal<LookupItem[]>([]);

  loadClientLookup() {
    if (!this.clientLookupItems().length) {
      this.httpClient
        .get<ClientListForMatterFilterResponse>(`${environment.apiUrl}/${APIUrls.GetAllClients}`)
        .pipe(
          catchError((error: HttpErrorResponse) => {
            return of({
              status: false,
              statusCode: error.status,
              message: 'Http error raising draft invoices',
              result: [],
            } as ClientListForMatterFilterResponse);
          }),
        )
        .subscribe((response) => {
          if (response.status) {
            this.clientLookupItems.set(
              response.result.map((x) => {
                return { id: x.id, title: x.clientName };
              }),
            );
          }
        });
    }
  }

  getTechUsedOptions(): Observable<TechUsedResponse[]> {
    return this.httpClient.get<TechUsedResponse[]>(`${environment.apiUrl}/Timesheet/GetTechUsedOptions`);
  }

}